module.exports = __webpack_public_path__ + "static/img/zhuce_ic_fuwujigou@2x.6aa9174f.png";